/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum InconsistenciesBeneficiarioAliases {
  FETCH_INCONSISTENCIAS = 'fetch-inconsistencias',
  IMAGE_0 = 'image-0',
  LAYOUT_0 = 'layout-0',
  LAYOUT_INCONSISTENCIAS = 'layout-inconsistencias',
  MAPPER_0 = 'mapper-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_INC = 'panel-inc',
  REPEATER_0 = 'repeater-0',
  TEXT_0 = 'text-0',
}
export { InconsistenciesBeneficiarioAliases };
